import { envs } from '@config'
import { datadogLogs } from '@datadog/browser-logs'

if (envs.ddEnv === 'production' || envs.ddEnv === 'staging') {
  datadogLogs.init({
    clientToken: envs.ddClientToken,
    service: envs.ddService,
    site: envs.ddSite,
    env: envs.ddEnv,
    version: envs.ddVersion,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}

export { datadogLogs }
